import useSSE from "../../hooks/useSSE";
import { useAuth } from "../authContext";
import { useGlobal } from "../globalContext";

// DO NOT use this hook directly in components or other hooks
// this is an internal hook that should be only used by JoinedMeetingScreenIOContextProvider, to provide centralized state management and logic control
export default function useIOSSE({
  // context managed states (general states for both of mouse and keyboard)
  IOEventSourceRef,

  setBackendReportingMouseControls,
  setLocalRequestingMouseControlScreenId,
  localRequestingMouseControlScreenId,

  setBackendReportingKeyboardControls,
  setLocalRequestingKeyboardControlScreenId,
  localRequestingKeyboardControlScreenId,
}) {
  const { MEETING_STATE } = useGlobal();
  const { userData } = useAuth();

  useSSE(IOEventSourceRef, MEETING_STATE.activeMeetingId && `/lw/${MEETING_STATE.activeMeetingId}/io/sse`, {
    "mouse-take-over": ({ userId, screenId }) => {
      console.log("IOSSE: mouse-take-over", { userId, screenId });
      if (screenId === localRequestingMouseControlScreenId && String(userId) !== userData.userId) {
        // we lost what we requested
        setLocalRequestingMouseControlScreenId();
      }

      setBackendReportingMouseControls((p) => ({ ...p, [screenId]: userId }));
    },
    "mouse-release": ({ userId, screenId }) => {
      console.log("IOSSE: mouse-release", { userId, screenId });
      if (screenId === localRequestingMouseControlScreenId && String(userId) === userData.userId) {
        // we lost what we requested
        setLocalRequestingMouseControlScreenId();
      }

      setBackendReportingMouseControls((p) => removeKeyVal(p, screenId, userId));
    },
    "kybd-take-over": ({ userId, screenId }) => {
      console.log("IOSSE: kybd-take-over", { userId, screenId });
      if (screenId === localRequestingKeyboardControlScreenId && String(userId) !== userData.userId) {
        // we lost what we requested
        setLocalRequestingKeyboardControlScreenId();
      }

      setBackendReportingKeyboardControls((p) => ({ ...p, [screenId]: userId }));
    },
    "kybd-release": ({ userId, screenId }) => {
      console.log("IOSSE: kybd-release", { userId, screenId });
      if (screenId === localRequestingKeyboardControlScreenId && String(userId) === userData.userId) {
        // we lost what we requested
        setLocalRequestingKeyboardControlScreenId();
      }

      setBackendReportingKeyboardControls((p) => removeKeyVal(p, screenId, userId));
    },
  });
}

function removeKeyVal(obj, key, val) {
  return Object.fromEntries(Object.entries(obj).filter(([k, v]) => String(k) !== String(key) || v !== val));
}
